class CarouselComponent extends HTMLElement {
  constructor() {
    super();
    this._mounted = false;
  }

  connectedCallback() {
    if (this._mounted) return;
    this.tryInit();
  }

  tryInit() {
    if (this._mounted) return;

    const rawOptions = this.dataset.options;
    if (!rawOptions) return;

    if (typeof window.Splide === 'undefined') {
      requestAnimationFrame(() => this.tryInit());
      return;
    }

    if (!this.querySelector('.splide__slide')) {
      requestAnimationFrame(() => this.tryInit());
      return;
    }

    let options;
    try {
      options = JSON.parse(rawOptions);
    } catch {
      console.error('Invalid Splide JSON:', rawOptions);
      return;
    }

    this.splide = new Splide(this, options);
    this.splide.mount();
    this._mounted = true;
  }

  disconnectedCallback() {
    this.splide?.destroy(true);
    this._mounted = false;
  }
}

customElements.define('carousel-component', CarouselComponent);
